export const DAILY_NEWSLETTER_TEMPLATES = {
  monday: {
    name: "Monday Market Movers",
    description: "Start the week with key market insights and analysis",
    steps: [{
      step_number: 1,
      channel: "email",
      content_template: {
        subject: "Monday Market Movers: Weekly EV Industry Kickoff",
        body: `# Monday Market Movers Newsletter

## Market Opening Analysis
- Key market indicators and pre-market movements
- Major stock futures and trends
- Global market influences

## Weekend Recap
- Important events from the weekend
- Corporate announcements
- Regulatory updates

## Week Ahead Preview
- Expected announcements and earnings
- Upcoming industry events
- Market-moving catalysts`
      },
      delay_hours: 0,
      subject_type: "static" as const,
      auto_trigger: true
    }]
  },
  tuesday: {
    name: "Tuesday Tech Focus",
    description: "Deep dive into EV technology and innovation",
    steps: [{
      step_number: 1,
      channel: "email",
      content_template: {
        subject: "Tuesday Technology & Innovation Update",
        body: `# Tuesday Technology & Innovation Update

## Technology Updates
- Latest EV technology developments
- Battery innovation news
- Software and connectivity updates

## Industry Moves
- Strategic partnerships
- M&A activity
- Executive changes`
      },
      delay_hours: 24,
      subject_type: "static" as const,
      auto_trigger: true
    }]
  },
  wednesday: {
    name: "Wednesday Market Watch",
    description: "Mid-week market analysis and trends",
    steps: [{
      step_number: 1,
      channel: "email",
      content_template: {
        subject: "Wednesday Market Watch: EV Industry Pulse",
        body: `# Wednesday Market Watch

## Market Analysis
- Mid-week market trends
- Trading volume analysis
- Price movement insights

## Industry Updates
- Manufacturing updates
- Supply chain news
- Regulatory developments

## Company Spotlights
- Notable company developments
- Executive interviews
- Strategic initiatives`
      },
      delay_hours: 48,
      subject_type: "static" as const,
      auto_trigger: true
    }]
  },
  thursday: {
    name: "Thursday Innovation Insights",
    description: "Focus on EV innovation and research",
    steps: [{
      step_number: 1,
      channel: "email",
      content_template: {
        subject: "Thursday Innovation Insights: EV Technology Frontier",
        body: `# Thursday Innovation Insights

## Research & Development
- Latest research breakthroughs
- Patent filings
- Academic partnerships

## Technology Trends
- Emerging technologies
- Industry standards
- Innovation metrics

## Future Outlook
- Technology roadmaps
- Industry predictions
- Research priorities`
      },
      delay_hours: 72,
      subject_type: "static" as const,
      auto_trigger: true
    }]
  },
  friday: {
    name: "Friday Week in Review",
    description: "Weekly wrap-up and analysis",
    steps: [{
      step_number: 1,
      channel: "email",
      content_template: {
        subject: "Friday Week in Review: EV Industry Roundup",
        body: `# Friday Week in Review

## Week's Highlights
- Major announcements
- Key developments
- Market movers

## Analysis & Insights
- Trend analysis
- Expert opinions
- Market sentiment

## Looking Ahead
- Upcoming events
- Expected announcements
- Market outlook`
      },
      delay_hours: 96,
      subject_type: "static" as const,
      auto_trigger: true
    }]
  }
};

export const getAllTemplates = () => {
  return Object.entries(DAILY_NEWSLETTER_TEMPLATES).map(([key, template]) => ({
    id: `daily-${key}`,
    ...template
  }));
};